<div class="advanced-search-dev">
  <div class="advanced-search-dev-header">
    <h2 mat-dialog-title class="advanced-search-dev-title">Advanced Search Dev</h2>
    <button class="advanced-search-dev-close" type="button" (click)="close()">Close</button>
  </div>

  <div class="advanced-search-dev-section generation-mode-item">
    <div class="generation-mode-header">
      <div>
        <h3 class="generation-mode-title">Advanced Search Generation</h3>
        <p class="generation-mode-copy">Choose how AI previews are generated on this browser.</p>
      </div>
      <span class="generation-mode-status">Saved: {{ getAdvancedSearchGenerationModeLabel(savedAdvancedSearchGenerationMode) }}</span>
    </div>

    <div class="generation-mode-grid">
      <button
        *ngFor="let mode of generationModes"
        type="button"
        class="generation-mode-button"
        [ngClass]="{ 'active': savedAdvancedSearchGenerationMode === mode.value }"
        (click)="setAdvancedSearchGenerationMode(mode.value)">
        <div class="generation-mode-button-title-row">
          <span class="generation-mode-button-title">{{ mode.title }}</span>
          <span class="generation-mode-button-badge" *ngIf="mode.deprecatedLabel">{{ mode.deprecatedLabel }}</span>
        </div>
        <span class="generation-mode-button-copy">{{ mode.description }}</span>
      </button>
    </div>

    <p class="generation-mode-note" *ngIf="routeAdvancedSearchGenerationModeOverride">
      Active now: {{ getAdvancedSearchGenerationModeLabel(effectiveAdvancedSearchGenerationMode) }} mode via URL override. Remove <strong>generationMode</strong> from the link to use the saved browser setting.
    </p>

    <div class="generation-mode-warning" *ngIf="!generationModeValidationState.isValid">
      <p class="generation-mode-warning-copy">
        Invalid generation mode "{{ generationModeValidationState.rawMode || 'unknown' }}" from
        {{ generationModeValidationState.source === 'route' ? 'URL override' : 'saved browser setting' }}.
      </p>
      <button
        type="button"
        class="generation-mode-reset-btn"
        (click)="onResetInvalidGenerationModeClick()">
        Reset to Economy Plus
      </button>
    </div>

    <div class="custom-settings-section" *ngIf="shouldShowCustomSettings">
      <div class="custom-settings-header">
        <span class="custom-settings-title">Custom Settings</span>
      </div>

      <div class="custom-count-row">
        <span class="custom-count-label">Asset count</span>
        <span class="custom-count-value">{{ customAssetCount }}</span>
      </div>
      <input
        class="custom-count-slider"
        type="range"
        [min]="customAssetCountMin"
        [max]="customAssetCountMax"
        [value]="customAssetCount"
        (input)="onCustomAssetCountInput($event)">

      <div class="custom-count-row">
        <span class="custom-count-label">Portrait temperature</span>
        <span class="custom-count-value">{{ customPortraitTemperature | number:'1.2-2' }}</span>
      </div>
      <input
        class="custom-count-slider"
        type="range"
        [min]="customTemperatureMin"
        [max]="customTemperatureMax"
        [step]="customTemperatureStep"
        [value]="customPortraitTemperature"
        (input)="onCustomPortraitTemperatureInput($event)">

      <div class="custom-count-row">
        <span class="custom-count-label">Landscape temperature</span>
        <span class="custom-count-value">{{ customLandscapeTemperature | number:'1.2-2' }}</span>
      </div>
      <input
        class="custom-count-slider"
        type="range"
        [min]="customTemperatureMin"
        [max]="customTemperatureMax"
        [step]="customTemperatureStep"
        [value]="customLandscapeTemperature"
        (input)="onCustomLandscapeTemperatureInput($event)">

      <div class="custom-prompt-header">
        <span class="custom-prompt-title">System prompt (Custom only)</span>
        <span class="custom-prompt-counter">{{ customSystemPrompt.length }}/{{ customSystemPromptMaxLength }}</span>
      </div>
      <textarea
        class="custom-prompt-textarea"
        [value]="customSystemPrompt"
        [attr.maxlength]="customSystemPromptMaxLength"
        placeholder="Added as Custom directive (highest priority) to portrait prompt."
        (input)="onCustomSystemPromptInput($event)"></textarea>
      <p class="custom-prompt-hint">
        Applied only in Custom mode as a high-priority suffix for portrait generation.
      </p>

      <div class="pair-model-section custom-rendering-model-section">
        <div class="pair-model-header">
          <span class="pair-model-title">Rendering Model</span>
          <span class="generation-mode-status">Saved: {{ getAdvancedSearchRenderingModelLabel(savedRenderingModel) }}</span>
        </div>

        <div class="pair-model-grid">
          <button
            *ngFor="let option of renderingModelOptions"
            type="button"
            class="generation-mode-button pair-model-button"
            [ngClass]="{ 'active': savedRenderingModel === option.value }"
            (click)="setRenderingModel(option.value)">
            <span class="generation-mode-button-title">{{ option.title }}</span>
            <span class="generation-mode-button-copy">{{ option.description }}</span>
          </button>
        </div>
      </div>

      <div class="pair-model-section custom-planner-model-section">
        <div class="pair-model-header">
          <span class="pair-model-title">Planner Model</span>
          <span class="generation-mode-status">Saved: {{ getAdvancedSearchPlannerModelLabel(savedPlannerModel) }}</span>
        </div>

        <div class="pair-model-grid">
          <button
            *ngFor="let option of plannerModelOptions"
            type="button"
            class="generation-mode-button pair-model-button"
            [ngClass]="{ 'active': savedPlannerModel === option.value }"
            (click)="setPlannerModel(option.value)">
            <span class="generation-mode-button-title">{{ option.title }}</span>
            <span class="generation-mode-button-copy">{{ option.description }}</span>
          </button>
        </div>
      </div>
    </div>

  </div>

  <div class="advanced-search-dev-section pair-batch-section">
    <label class="pair-debug-toggle">
      <span>
        <span class="pair-debug-title">Preview Debug Mode</span>
        <span class="pair-debug-copy">Open pair batch composites instead of the landscape preview.</span>
      </span>
      <input
        type="checkbox"
        [checked]="pairPreviewDebugMode"
        (change)="onPairPreviewDebugModeChange($event)">
      <span class="pair-debug-switch" aria-hidden="true"></span>
    </label>
  </div>

</div>
